import { createSlice } from "@reduxjs/toolkit";
import {
    resetAppontmentData,
    resetExisttAppointment,
} from "../../utils/constants";
import { IAppointmentSlice } from "../../shared/interfaces/schedulePage";

const initialState: IAppointmentSlice = {
    newAppointment: resetAppontmentData,
    existtAppointment: resetExisttAppointment,
};

const appointmentSlice = createSlice({
    name: "appointments",
    initialState,
    reducers: {
        updateNewAppointment: (state, action) => {
            Object.assign(state.newAppointment, action.payload);
        },
        updateExistAppointment: (state, action) => {
            Object.assign(state.existtAppointment, action.payload);
        },
        addServisesToNewAppointment: (state, action) => {
            state.newAppointment.services = [
                action.payload,
                ...(state.newAppointment.services || []),
            ];
        },
        addServisesToExsistAppointment: (state, action) => {
            state.existtAppointment.services = [
                action.payload,
                ...(state.existtAppointment.services || []),
            ];
        },
        setQuantity(state, action) {
            const { id, actualQuantity, isEditAppointment } = action.payload;
            const appointment =
                state[
                    isEditAppointment ? "existtAppointment" : "newAppointment"
                ];

            const service = appointment.services.find(s => s._id === id);

            if (service) {
                service.quantity = actualQuantity;
            }
        },
        setDiscount(state, action) {
            const { id, actualDiscount, isEditAppointment } = action.payload;
            const service = state[
                isEditAppointment ? "existtAppointment" : "newAppointment"
            ].services.find(s => s._id === id);
            if (service) {
                service.discount = actualDiscount;
            }
        },
        deleteServisesFromNewAppointment: (state, action) => {
            if (state.newAppointment.services) {
                const newArray = state.newAppointment.services.filter(
                    item => item._id !== action.payload,
                );
                state.newAppointment.services = newArray;
            }
        },
        deleteServisesFromExistAppointment: (state, action) => {
            if (state.existtAppointment.services) {
                const newArray = state.existtAppointment.services.filter(
                    item => item._id !== action.payload,
                );
                state.existtAppointment.services = newArray;
            }
        },
        resetNewAppointmentData: state => {
            state.newAppointment = { ...resetAppontmentData };
        },
        resetExistAppointmentData: state => {
            state.existtAppointment = { ...resetExisttAppointment };
        },
        updateServicePriceToNewAppointment: (state, action) => {
            const { id, price } = action.payload;
            const service = state.newAppointment.services.find(
                service => service._id === id,
            );
            if (service) {
                service.price = price;
            }
        },
        updateServicePriceToExistAppointment: (state, action) => {
            const { id, price } = action.payload;
            const service = state.existtAppointment.services.find(
                service => service._id === id,
            );
            if (service) {
                service.price = price;
            }
        },
    },
});

export const {
    updateNewAppointment,
    addServisesToNewAppointment,
    deleteServisesFromNewAppointment,
    resetNewAppointmentData,
    updateServicePriceToNewAppointment,
    updateServicePriceToExistAppointment,
    updateExistAppointment,
    addServisesToExsistAppointment,
    deleteServisesFromExistAppointment,
    resetExistAppointmentData,
    setQuantity,
    setDiscount,
} = appointmentSlice.actions;
export default appointmentSlice.reducer;
